module.exports = __webpack_public_path__ + "static/media/prickly.752754b6.png";